export function camelToSpace(value: string): string {
    return value.replace(/[\w]([A-Z])/g, (m) => {
        return m[0] + ' ' + m[1];
    }).toLowerCase();
}
